"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyLoginPwdRequest = void 0;
var VerifyLoginPwdRequest = /** @class */ (function () {
    function VerifyLoginPwdRequest() {
    }
    return VerifyLoginPwdRequest;
}());
exports.VerifyLoginPwdRequest = VerifyLoginPwdRequest;
;
//# sourceMappingURL=verifyLoginPwd.request.js.map